import React from 'react';
import { Image } from '../../../../wag-react/next-components/image';
import QuoteIcon from '../../../../assets/icons/walker-profile/assets/quote.svg';
import { BoxProps } from '../../../../wag-react/next-components/box';
import { theme } from '../../../../wag-react/themes/base-theme';
import { Box } from '../../../../wag-react/core-components/box';
import { Typography } from '../../../../wag-react/components/Typography';
type Props = {
  catchphrase: string;
  containerProps?: BoxProps;
};
export const WalkerCatchphrase = ({
  catchphrase,
  containerProps = {}
}: Props) => <Box bg={theme.colors.whiteSmoke} fontFamily="muli" color="#818181" borderRadius="5px" p="11px" display="flex" width="fit-content" {...containerProps} data-sentry-element="Box" data-sentry-component="WalkerCatchphrase" data-sentry-source-file="WalkerCatchphrase.tsx">
    <Image width="7px" height="7px" mr={1} src={QuoteIcon} alt="Quote icon" data-sentry-element="Image" data-sentry-source-file="WalkerCatchphrase.tsx" />
    <Typography color="#272727" px="4px" variant="body1" fontSize="14px" fontFamily="muliBold" m="0" data-sentry-element="Typography" data-sentry-source-file="WalkerCatchphrase.tsx">
      {catchphrase}
    </Typography>
    <Image className="rotate-180" width="7px" height="7px" src={QuoteIcon} ml={1} alt="Quote icon" data-sentry-element="Image" data-sentry-source-file="WalkerCatchphrase.tsx" />
  </Box>;